import { Helmet } from 'react-helmet';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import About from '../../components/light/creative-portfolio/About';
import Blog from '../../components/light/creative-portfolio/Blog';
import Footer from '../../components/light/creative-portfolio/Footer';
import Header from '../../components/light/creative-portfolio/Header';
import Marquee from '../../components/light/creative-portfolio/Marquee';
import Navbar from '../../components/light/creative-portfolio/Navbar';
import Portfolio from '../../components/light/creative-portfolio/Portfolio';
import Services from '../../components/light/creative-portfolio/Services';
import Team from '../../components/light/creative-portfolio/Team';
import Testimonials from '../../components/light/creative-portfolio/Testimonials';

export default function LHomeCreativePortfolio() {
  return (
    <>
      <Helmet>
        <title>infolio</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body className="crev-portfolio">
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg pt-15">
              <div className="sub-bg radius-30 o-hidden">
                <Header />
                <Portfolio />
              </div>
              <Services />
              <About />
              <Testimonials />
              <Team />
              <Marquee />
              <Blog />
              <Footer />
            </main>
          </div>
        </div>
      </body>
    </>
  );
}
